export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-6xl mx-auto px-4 py-10 text-center">
        <div className="text-3xl mb-3">🇹🇷</div>
        <h3 className="text-xl font-black mb-2" style={{ fontFamily: "'Merriweather', serif" }}>
          23 Nisan Gazetesi
        </h3>
        <p className="text-primary-foreground/70 text-sm max-w-md mx-auto mb-6">
          Ortaokul öğrencileri için hazırlanmış bu özel dijital gazete,
          23 Nisan'ın tarihsel önemini anlatmak amacıyla oluşturulmuştur.
        </p>
        <div className="flex flex-wrap justify-center gap-6 text-sm text-primary-foreground/60 mb-6">
          {[
            "🏛️ TBMM — 1920",
            "👶 Çocuk Bayramı — 1927",
            "🌍 Uluslararası — 1979",
            "🎊 106. Yıl — 2026",
          ].map((item) => (
            <span key={item} className="font-medium">{item}</span>
          ))}
        </div>
        <div className="border-t border-white/20 pt-5 text-xs text-primary-foreground/50">
          <p className="italic mb-1">"Egemenlik kayıtsız şartsız milletindir." — Mustafa Kemal Atatürk</p>
          <p>© 2026 · 23 Nisan Dijital Gazetesi · Ortaokul Öğrencileri için Hazırlandı</p>
        </div>
      </div>
    </footer>
  );
}
